import { render } from "./MonogramPreview.vue?vue&type=template&id=5015a819&scoped=true"
import script from "./MonogramPreview.vue?vue&type=script&lang=js"
export * from "./MonogramPreview.vue?vue&type=script&lang=js"

import "./MonogramPreview.vue?vue&type=style&index=0&id=5015a819&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5015a819"]])

export default __exports__